export default "__VITE_ASSET__BAxyVONR__"